import { Button, ButtonBase } from '@mui/material';
import { useEffect, useState } from 'react';
import PreSetBonus from './PreSetBonus';
import ManageBonus from './ManageBonus';
import AddDealerBonus from '../SingleLoanProduct/AddDealerBonus';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBonus, getBonus } from '../../redux/slice/bonusSlice';
import { useLocation } from 'react-router-dom';
import { setDealerBonusFilter } from '../../redux/slice/loanFilterSlice';
import CommonPopup from '../../components/popup/CommonPopup';
import SwitchBox from '../../components/SwitchBox/SwitchBox';
import { BankProvider, Category, Motor, Scheme, Type, Usage } from './UserData';
import SwitchButton from '../../components/SwitchButton/SwitchButton';
import axios from '../../axios/axios';
import { toast } from 'react-toastify';

const DealerBonus = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const pagePermissions = location.state;
  const settings = useSelector((state) => state.settings);
  const dealerBonusFilter = useSelector(
    (state) => state.loanProductFilter?.dealerBonusFilter
  );
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isHighTemp, setIsHighTemp] = useState(false);
  const [tabIdx, setTabIdx] = useState(
    dealerBonusFilter?.tabId !== undefined ? dealerBonusFilter?.tabId : 0
  );
  const bonusCard = useSelector(getBonus);
  const [dealerPopUp, setDealerPopUp] = useState(false);
  const [searchTerm, setsearchTerm] = useState(
    dealerBonusFilter?.search !== undefined ? dealerBonusFilter?.search : ''
  );
  const [editBonusData, setEditBonusData] = useState(null);
  const [dealerBonusProducts, setDealerBonusProducts] = useState([]);
  const [dealerBonusList, setDealerBonusList] = useState([]);
  const [settingsData, setSettingsData] = useState({});
  const [multiSelect, setMultiSelect] = useState([]);

  const DefaultFilters = {
    vehicle: '',
    category: '',
    loanType: '',
    scheme: '',
    motorType: '',
    usage: '',
    loanProvider: '',
    bonus: '0',
    toggleSwitch: 'lt',
    status: 1,
    index: '0',
    keyword: '',
    sortKey: 'created_at',
    sortOrder: 'asc',
    collect_first_installment: '',
  };
  console.log('dealerBonusFilter', dealerBonusFilter);
  const [applyFilters, setApplyFilters] = useState(
    Object.keys(dealerBonusFilter)?.length > 0
      ? { ...DefaultFilters, ...dealerBonusFilter }
      : DefaultFilters
  );
  const [selectedAccordian, setSelectedAccordian] = useState([]);
  const [selectedDealerBonus, setSelectedDealerBonus] = useState([]);
  const [settingsIndex, setSettingsIndex] = useState(
    Object.keys(dealerBonusFilter)?.length > 0 &&
      dealerBonusFilter?.settingsIndex !== undefined
      ? dealerBonusFilter?.settingsIndex
      : {
        veh: 0,
        cat: 0,
        typ: 0,
        schm: 0,
      }
  );
  const handleBonusPopUp = (state) => {
    setDealerPopUp(!dealerPopUp);
    setEditBonusData(null);
  };
  const editBonusCard = (state) => {
    setEditBonusData(state);
    setDealerPopUp(!dealerPopUp);
  };
  useEffect(() => {
    dispatch(fetchBonus(searchTerm));
  }, [dispatch, searchTerm]);

  const openFilterPopup = () => {
    setIsPopupOpen(true);
  };

  const closeFilterPopup = () => {
    setIsPopupOpen(false);
  };

  const handleSettingsChange = (idx, title, tabId) => { };

  const handleSwitch = (newState) => {
    setIsHighTemp(newState);
  };

  const SetFilterState = (filterobj) => {
    dispatch(setDealerBonusFilter(filterobj));
  };

  const settingsHandle = (idx, title, tabId) => {
    switch (title) {
      case 'vehicle':
        console.log("data vehicle", settingsData.vehicles[idx].id)
        setSettingsIndex({
          ...settingsIndex,
          veh: idx,
          typ: 0,
        });
        setApplyFilters({
          ...applyFilters,
          vehicle: settingsData.vehicles[idx].id,
        });
        SetFilterState({
          ...applyFilters,
          vehicle: settingsData.vehicles[idx].id,
        });
        break;
      case 'category':
        setSettingsIndex({
          ...settingsIndex,
          cat: idx,
          typ: 0,
        });
        setApplyFilters({
          ...applyFilters,
          category: settingsData.categories[idx].id,
          loanType: settingsData.categories[idx].types[0].id,
          scheme: settingsData.categories[idx].types[0].schemes[0].id,
        });
        SetFilterState({
          ...applyFilters,
          category: settingsData.categories[idx].id,
          loanType: settingsData.categories[idx].types[0].id,
          scheme: settingsData.categories[idx].types[0].schemes[0].id,
          settingsIndex: {
            ...settingsIndex,
            cat: idx,
            typ: 0,
          },
        });
        break;
      case 'type':
        setSettingsIndex({
          ...settingsIndex,
          typ: idx,
          schm: 0,
        });
        setApplyFilters({
          ...applyFilters,
          loanType: tabId,
          scheme:
            settingsData.categories[settingsIndex.cat].types[idx].schemes[0].id,
        });
        SetFilterState({
          ...applyFilters,
          loanType: tabId,
          scheme:
            settingsData.categories[settingsIndex.cat].types[idx].schemes[0].id,
          settingsIndex: {
            ...settingsIndex,
            typ: idx,
            schm: 0,
          },
        });
        break;
      case 'scheme':
        setSettingsIndex({ ...settingsIndex, schm: idx });
        setApplyFilters({
          ...applyFilters,
          loanType:
            settingsData.categories[settingsIndex.cat].types[settingsIndex.typ]
              .id,
          scheme: tabId,
        });
        SetFilterState({
          ...applyFilters,
          loanType:
            settingsData.categories[settingsIndex.cat].types[settingsIndex.typ]
              .id,
          scheme: tabId,
          settingsIndex: {
            ...settingsIndex,
            schm: idx,
          },
        });
        break;
      case 'motor':
        setApplyFilters({
          ...applyFilters,
          motorType: tabId,
        });
        SetFilterState({
          ...applyFilters,
          motorType: tabId,
        });
        break;
      case 'usage':
        setApplyFilters({
          ...applyFilters,
          usage: tabId,
        });
        SetFilterState({
          ...applyFilters,
          usage: tabId,
        });
        break;
      case 'bank provider':
        setApplyFilters({
          ...applyFilters,
          loanProvider: tabId,
        });
        SetFilterState({
          ...applyFilters,
          loanProvider: tabId,
        });
        break;
      case 'collect first installment?':
        setApplyFilters({
          ...applyFilters,
          collect_first_installment: tabId,
        });
        SetFilterState({
          ...applyFilters,
          collect_first_installment: tabId,
        });
        break;
      default:
        break;
    }
  };
  const getSettings = async () => {
    const resp = await axios.get('/settings');
    let temp = resp.data?.data;
    for (let prop in temp) {
      temp[prop] = [
        {
          name: 'All',
          id: '',
          types: [{ id: '', name: 'All', schemes: [{ id: '', name: 'All' }] }],
        },
      ].concat(temp[prop]);
    }
    setSettingsData(resp?.data?.data);
  };
  console.log('APPLY FILTERS', applyFilters);

  const GetDealerBonusProducts = async () => {
    const FIlterObj = {
      ...applyFilters,
    };
    const resp = await axios.post('/loan/product/groups', FIlterObj);
    if (resp.status < 400) {
      setDealerBonusProducts(resp.data?.data);
    }
  };
  const GetDealerBonusList = async () => {
    const resp = await axios.post('/loan/bonus/list', {});
    if (resp.status < 400) {
      setDealerBonusList(resp.data?.data);
    }
  };

  const UpdateBonus = async () => {
    const resp = await axios.put('/interest/bonus/bulk/update', {
      items: selectedDealerBonus?.filter((it) => it?.interest_bonus !== ''),
    });
    if (resp.status < 400) {
      toast.success(resp.data?.message);
      setMultiSelect([]);
      setSelectedDealerBonus([]);
      GetDealerBonusProducts();
    }
  };
  const HandleMultiSelect = (ProductObj) => {
    const filtered = dealerBonusProducts
      .filter((it) => it.id == ProductObj?.Product_Id)
      ?.map((item) => item.products)
      .flat();
    console.log('FILTERE', ProductObj);
    const newState = filtered.map((obj) => {
      return {
        product: obj.id,
        interest: obj.activeinterest.id,
        interest_bonus:
          obj?.activeinterest?.agentbonusinfo !== null
            ? obj?.activeinterest?.agentbonusinfo?.id
            : '',
        agent_bonus: ProductObj.agent_bonus,
        Product_Id: ProductObj.Product_Id,
      };
    });
    if (
      selectedDealerBonus
        ?.map((it) => it?.Product_Id)
        ?.includes(ProductObj?.Product_Id)
    ) {
      setSelectedDealerBonus(
        selectedDealerBonus
          .filter((it) => it.Product_Id !== ProductObj.Product_Id)
          .concat(newState)
      );
    } else {
      setSelectedDealerBonus(selectedDealerBonus.concat(newState));
    }
  };
  const HandleAllSelect = (ProductObj) => {
    var filtered = dealerBonusProducts.filter(function (item) {
      return multiSelect.indexOf(item.id) !== -1;
    });
    console.log('filtered', filtered);
    const newState = filtered
      .map((it) => it.products)
      .flat()
      .map((obj) => {
        return {
          product: obj.id,
          interest: obj.activeinterest.id,
          interest_bonus:
            obj?.activeinterest?.agentbonusinfo !== null
              ? obj?.activeinterest?.agentbonusinfo?.id
              : '',
          agent_bonus: ProductObj.agent_bonus,
          Product_Id: obj.loanProvider,
        };
      });
    setSelectedDealerBonus(newState);
  };

  const HandleDealerSelection = (ProductObj) => {
    if (ProductObj?.isMultiSelect !== undefined && ProductObj?.isMultiSelect) {
      HandleMultiSelect(ProductObj);
    } else if (
      ProductObj?.isAllSelect !== undefined &&
      ProductObj?.isAllSelect
    ) {
      HandleAllSelect(ProductObj);
    } else {
      if (selectedDealerBonus?.length > 0) {
        if (
          selectedDealerBonus
            ?.map((it) => it?.product)
            ?.includes(ProductObj.product)
        ) {
          setSelectedDealerBonus([
            ...selectedDealerBonus.filter(
              (it) => it.product !== ProductObj.product
            ),
            ProductObj,
          ]);
        } else {
          setSelectedDealerBonus([...selectedDealerBonus, ProductObj]);
        }
      } else {
        setSelectedDealerBonus([...selectedDealerBonus, ProductObj]);
      }
    }
  };

  useEffect(() => {
    GetDealerBonusList();
    getSettings();
  }, []);
  useEffect(() => {
    GetDealerBonusProducts();
  }, [applyFilters]);
  console.log('selectedDealerBonus', selectedDealerBonus);
  return (
    <div className='flex_adjust bg-[#F5F5F5] min-h-screen'>
      {dealerPopUp && (
        <AddDealerBonus
          editData={editBonusData}
          closeBonusPopUp={handleBonusPopUp}
        />
      )}
      <div className='bg-white'>
        <div className='flex pt-[20px] justify-between items-center px-[24px] max-[700px]:flex-col max-[700px]:items-start'>
          <div className='font-[700] text-[20px] max-[700px]:mb-[15px]'>
            Dealer Bonus
          </div>
          <div className='flex items-center max-[700px]:w-full max-[700px]:justify-between'>
            <div className='relative w-[250px] max-w-[100%] max-[700px]:w-[100%]'>
              <div className='absolute h-[100%] top-[0] left-[0] flex items-center max-[768px]:left-[10px] max-[768px]:top-[-2px]'>
                <img
                  src='/images/search.svg'
                  alt='search'
                  className='pt-[3px]'
                />
              </div>
              <input
                type='search'
                placeholder={
                  tabIdx == 0
                    ? 'Search Loan Products...'
                    : 'Search Dealer Bonus...'
                }
                className='pl-[25px] outline-none text-[13px]  max-[768px]:border max-[768px]:border-gray-200 max-[768px]:p-[8px_20px_8px_33px] max-[768px]:rounded-[5px] max-[700px]:w-[calc(100%-20px)]'
                value={searchTerm}
                onChange={(e) => {
                  setsearchTerm(e.target.value);
                  dispatch(
                    setDealerBonusFilter({
                      search: e.target.value,
                      tabId: tabIdx,
                    })
                  );
                  setApplyFilters({ ...applyFilters, keyword: e.target.value });
                }}
              />
            </div>
            {pagePermissions?.create_permission == 1 && (
              <Button
                type='button'
                className='sav_btn bonus_btn'
                disabled={bonusCard.bonus.length >= 8}
                onClick={() => setDealerPopUp(!dealerPopUp)}
              >
                <img
                  src='/images/add-circle-wh.svg'
                  alt='add'
                  className='hidden max-[700px]:block'
                />
                <span className='max-[700px]:hidden'>
                  Create New Dealer Bonus
                </span>
              </Button>
            )}
            <Button
              type='button'
              className='sav_btn bonus_btn filter'
              onClick={openFilterPopup}
            >
              <img src='/images/filter_icon.png' alt='filter' />
            </Button>
          </div>
        </div>
        <div className='flex items-center justify-between mt-[12px] border-b-2 border-[#EAEAEA] px-[24px] max-[768px]:gap-[20px] max-[768px]:pr-[3px]'>
          <div className='tab_Sec_box'>
            <div className='tab_Sec flex gap-[0_30px]'>
              {['Manage Bonus', 'Pre-set Dealer Bonus'].map((tab, idx) => {
                return (
                  <ButtonBase key={idx}>
                    <div
                      className={`tab_menu ${tabIdx === idx && 'active'}`}
                      onClick={() => {
                        dispatch(
                          setDealerBonusFilter({
                            search: searchTerm,
                            tabId: idx,
                          })
                        );
                        setTabIdx(idx);
                      }}
                    >
                      {tab}
                    </div>
                  </ButtonBase>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      <div className='min-h-screen'>
        {tabIdx ? (
          <PreSetBonus
            searchTerm={searchTerm}
            editBonusCard={editBonusCard}
            pagePermissions={pagePermissions}
          />
        ) : (
          Object.keys(settingsData)?.length > 0 && (
            <ManageBonus
              pagePermissions={pagePermissions}
              dealerBonusProducts={dealerBonusProducts}
              dealerBonusList={dealerBonusList}
              selectedAccordian={selectedAccordian}
              setSelectedAccordian={setSelectedAccordian}
              HandleDealerSelection={HandleDealerSelection}
              selectedDealerBonus={selectedDealerBonus}
              UpdateBonus={UpdateBonus}
              settingsData={settingsData}
              settingsIndex={settingsIndex}
              settingsHandle={settingsHandle}
              applyFilters={applyFilters}
              setApplyFilters={setApplyFilters}
              setMultiSelect={setMultiSelect}
              multiSelect={multiSelect}
              setSelectedDealerBonus={setSelectedDealerBonus}
            />
          )
        )}
        {Object.keys(settingsData)?.length > 0 && (
          <CommonPopup
            size='sm'
            position='left'
            isOpen={isPopupOpen}
            onClose={closeFilterPopup}
            className='full-y'
            title='Filter'
          >
            <SwitchBox
              title='Vehicle'
              tabs={settingsData?.vehicles}
              settingsHandle={settingsHandle}
              value={applyFilters?.vehicle}
            />
            <SwitchBox
              title='Type'
              tabs={settingsData?.categories}
              settingsHandle={settingsHandle}
              value={applyFilters?.category}
            />
            <SwitchBox
              title='Category'
              tabs={
                settingsData.categories[
                  settingsIndex.cat == 0
                    ? settingsIndex.cat + 1
                    : settingsIndex.cat
                ].types
              }
              settingsHandle={settingsHandle}
              value={applyFilters?.loanType}
              disabled={settingsIndex.cat == 0}
            />
            <SwitchBox
              title='Scheme'
              tabs={
                settingsData.categories[
                  settingsIndex.cat == 0
                    ? settingsIndex.cat + 1
                    : settingsIndex.cat
                ].types[settingsIndex.typ].schemes.map((scheme) => ({
                    ...scheme,
                    disabled:
                      settingsData.vehicles[settingsIndex.veh]?.name === 'Commercial' &&
                      scheme.name === 'Balloon',
                  }))
              }
              settingsHandle={settingsHandle}
              value={applyFilters?.scheme}
              disabled={settingsIndex.cat == 0}
            />
            <SwitchBox
              title='Motor'
              tabs={settingsData?.productMotorTypes}
              settingsHandle={settingsHandle}
              value={applyFilters?.motorType}
            />
            <SwitchBox
              title='Usage'
              tabs={settingsData?.productUsages}
              settingsHandle={settingsHandle}
              value={applyFilters?.usage}
            />
            <SwitchBox
              title='Bank Provider'
              tabs={settingsData?.loanProviderTypes}
              settingsHandle={settingsHandle}
              value={applyFilters?.loanProvider}
            />
            <SwitchBox
              title='Collect First Installment?'
              value={applyFilters?.collect_first_installment}
              tabs={
                Array.isArray(settingsData.collect_first_installment_options) &&
                  settingsData.collect_first_installment_options !== null
                  ? settingsData.collect_first_installment_options.map(
                    (it) => ({
                      ...it,
                      id: it?.value !== undefined ? it.value : '',
                    })
                  )
                  : []
              }
              settingsHandle={settingsHandle}
            />
            <SwitchButton
              initialState={isHighTemp}
              onSwitch={handleSwitch}
              leftLabel='LT'
              rightLabel='HT'
              tooltipText='Coming soon'
              showTooltip={true}
              classNames='!flex mt-4'
              right={applyFilters?.toggleSwitch === 'ht' ? true : false}
            />
          </CommonPopup>
        )}
      </div>
    </div>
  );
};

export default DealerBonus;
